export interface ICadastroListaDAL {
    CadastroNo: number;
	VariavelRetornoNo: number;
	Versao: number;
	BlResumido: boolean;
	lstCadastro: any;
	lstCadastroAdicional: any;
}
